import { Component, TemplateRef, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { TemplatePortal } from '@angular/cdk/portal';

@Component({
    selector: 'eui-tab-content, euiTabContent',
    template: `<ng-template #euiTabContent><ng-content></ng-content></ng-template>`,
})
export class EuiTabContentComponent implements AfterViewInit {

    @ViewChild('euiTabContent') templateRef: TemplateRef<any>;

    private templatePortal: TemplatePortal<any>;

    constructor(private viewContainerRef: ViewContainerRef) {
    }

    ngAfterViewInit(): void {
        this.templatePortal = new TemplatePortal(this.templateRef, this.viewContainerRef);
    }
}
